<template>
  <div class="hris-profile-link-candidates">
    <v-card
      variant="outlined"
      rounded="lg"
      class="pa-3"
    >
      <template v-if="candidates.length === 0">
        <p class="text-body-3 text-textLight">
          No Workday profiles found. Try updating the job code or title to find a match.
        </p>
      </template>

      <template v-else>
        <p class="text-body-3 text-textLight mb-2">
          {{ candidates.length }} Workday profile {{ candidates.length === 1 ? 'match' : 'matches' }} found.
        </p>
        <v-btn
          variant="outlined"
          color="primary"
          rounded="lg"
          size="small"
          :disabled="rescorePending"
          @click="setModal({ field: 'hrisProfileLink', value: true })"
        >
          Link to Workday profile
        </v-btn>
      </template>
    </v-card>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useModals } from '@/stores/modals/modals';

const { jobProfile, rescorePending } = storeToRefs(useCurrentJobProfile());
const { setModal } = useModals();

const candidates = computed(() => jobProfile.value?.hris_matching ?? []);
</script>

<style lang="less" scoped>
.hris-profile-link-candidates .v-card {
  border-color: @stroke-default;
}
</style>
